import React from 'react';
import { cardShape } from '@bibliocommons/bc-prop-types';

export default function ContentCardDescription({ card }) {
  const description = card.getIn(['description', 'text']);
  return description ? <div className="cp-content-card-description">{description}</div> : null;
}

ContentCardDescription.propTypes = {
  card: cardShape.isRequired
};
